function set(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function get(key) {
  return JSON.parse(localStorage.getItem(key));
}

function remove(key) {
  return localStorage.removeItem(key);
}

export default { get, set, remove };
